import React, {Component} from 'react'
import {Container, Table} from 'semantic-ui-react'
import {withRouter} from "react-router";
import * as firebase from "firebase";

const HEADERS = {
	services: 'Servicios'
}

class Status extends Component {

	constructor(props) {
		super(props);

		this.state = {
			status: undefined
		}
	}

	componentDidMount() {
		this.refresh();
		setTimeout(this.refresh, 15000)
	}

	refresh = () => {
		firebase.firestore().collection('status').doc('current').get().then(status => {
			console.log(status.data());
			this.setState({status: status.data()}, () => {
				let down = false;
				Object.keys(this.state.status).forEach(key => {
					Object.keys(this.state.status[key]).forEach(item => {
						if (this.state.status[key][item].status !== 'ACTIVE') {
							down = true;
						}
					});
				});

				if (down) {
					document.getElementById("favicon").href = 'https://status.myrealfood.app/favicon_down.ico'
				} else {
					document.getElementById("favicon").href = 'https://status.myrealfood.app/favicon_up.ico'
				}

				setTimeout(this.refresh, 15000)
			})
		}).catch(error => {
			setTimeout(this.refresh, 15000)
		})
	}

	render() {
		return (
			<Container style={{marginTop: '1em'}}>
				<Table unstackable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Machines</Table.HeaderCell>
							<Table.HeaderCell></Table.HeaderCell>
							<Table.HeaderCell></Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Nombre</Table.HeaderCell>
							<Table.HeaderCell>Descripción</Table.HeaderCell>
							<Table.HeaderCell>Estado</Table.HeaderCell>
						</Table.Row>
					</Table.Header>

					<Table.Body>
						{!!this.state.status && !!this.state.status.machines && Object.keys(this.state.status.machines).sort((s1, s2) => {
							return this.state.status.machines[s1].name.localeCompare(this.state.status.machines[s2].name);
						}).map(item => {
							return (
								<Table.Row>
									<Table.Cell>{this.state.status.machines[item].name}</Table.Cell>
									<Table.Cell>{this.state.status.machines[item].description}</Table.Cell>
									<Table.Cell>{this.state.status.machines[item].status === 'ACTIVE' ? '✅' : '❌'}{"  "}{this.state.status.machines[item].status === 'ACTIVE' ? 'UP' : 'DOWN'}</Table.Cell>
								</Table.Row>
							)
						})}
					</Table.Body>
				</Table>

				<Table unstackable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Services</Table.HeaderCell>
							<Table.HeaderCell></Table.HeaderCell>
							<Table.HeaderCell></Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Nombre</Table.HeaderCell>
							<Table.HeaderCell>Descripción</Table.HeaderCell>
							<Table.HeaderCell>Estado</Table.HeaderCell>
						</Table.Row>
					</Table.Header>

					<Table.Body>
						{!!this.state.status && !!this.state.status.services && Object.keys(this.state.status.services).sort((s1, s2) => {
							return this.state.status.services[s1].name.localeCompare(this.state.status.services[s2].name);
						}).map(item => {
							return (
								<Table.Row>
									<Table.Cell>{this.state.status.services[item].name}</Table.Cell>
									<Table.Cell>{this.state.status.services[item].description}</Table.Cell>
									<Table.Cell>{this.state.status.services[item].status === 'ACTIVE' ? '✅' : '❌'}{"  "}{this.state.status.services[item].status === 'ACTIVE' ? 'UP' : 'DOWN'}</Table.Cell>
								</Table.Row>
							)
						})}
					</Table.Body>
				</Table>

				<Table unstackable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Custom</Table.HeaderCell>
							<Table.HeaderCell></Table.HeaderCell>
							<Table.HeaderCell></Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Nombre</Table.HeaderCell>
							<Table.HeaderCell>Descripción</Table.HeaderCell>
							<Table.HeaderCell>Estado</Table.HeaderCell>
						</Table.Row>
					</Table.Header>

					<Table.Body>
						{!!this.state.status && !!this.state.status.custom && Object.keys(this.state.status.custom).sort((s1, s2) => {
							return this.state.status.custom[s1].name.localeCompare(this.state.status.custom[s2].name);
						}).map(item => {
							return (
								<Table.Row>
									<Table.Cell>{this.state.status.custom[item].name}</Table.Cell>
									<Table.Cell>{this.state.status.custom[item].description}</Table.Cell>
									<Table.Cell>{this.state.status.custom[item].status === 'ACTIVE' ? '✅' : '❌'}{"  "}{this.state.status.custom[item].status === 'ACTIVE' ? 'UP' : 'DOWN'}</Table.Cell>
								</Table.Row>
							)
						})}
					</Table.Body>
				</Table>
			</Container>
		)
	}
}

export default withRouter(Status);



// WEBPACK FOOTER //
// ./src/routes/Status/index.js